import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { CODES } from "../../consts/codes";
import { GetStores } from "../../services/user/stores/storesService";

/** Slice de Redux para el estado de tiendas. */
export const storesSlice = createSlice({
  name: "stores",
  initialState: {
    stores: [],
    storesStatus: "fetch",
  },
  reducers: {
    /** Resetea el estado de tiendas al estado inicial. */
    resetStoresState(state, action) {
      state.storesStatus = "fetch";
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchStores.pending, (state, action) => {
        state.storesStatus = "loading";
      })
      .addCase(fetchStores.fulfilled, (state, action) => {
        state.storesStatus = "succeeded";
        state.stores = action.payload;
      })
      .addCase(fetchStores.rejected, (state, action) => {
        state.storesStatus = "failed";
        state.stores = [];
      });
  },
});

/** Obtiene la lista de tiendas del estado. */
export const getStores = (state) => state.stores.stores;

/** Obtiene el estado de la petición de tiendas. */
export const getStoresStatus = (state) => state.stores.storesStatus;

export const { resetStoresState } = storesSlice.actions;

/** Obtiene la lista de tiendas desde el servicio. */
export const fetchStores = createAsyncThunk("catalogue/fetchAllStores", async (data) => {
  //TODO: Ajustar el objeto GetStores por integracion de grupo empresarial¨
  data["idFileType"] = 3;
  const requestStoresList = await GetStores({
    ...data,
  });
  if (requestStoresList.status === CODES.COD_RESPONSE_SUCCESS) {
    if (requestStoresList.data.responseCode === CODES.COD_RESPONSE_SUCCESS) {
      return requestStoresList.data.data;
    }
  }
});

/** Reducer de tiendas. */
export default storesSlice.reducer;